import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { WarningFilled } from "@ant-design/icons";
import { AppContext } from "../../contexts/AppContext";
import SubHeader from "../../components/SubHeader/SubHeader";
import GeneralButton from "../../components/GeneralButton/GeneralButton";
import Toast from "../../components/Toast/Toast";
import { registPatientMedicalQuestionnaire } from "../../services/service";
import "../../styles/globals.css";
import "./QuestionnaireConfirmPage.css";

/**
 * 問診確認画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function QuestionnaireConfirmPage() {
  const {
    globalMedicalInstitutionId,
    globalMedicalInstitutionName,
    globalAnswerInformation,
    globalQuestionnaireToken,
  } = useContext(AppContext);
  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState(null);

  /**
   * コンポーネントがマウントされた時にデータを取得
   */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /**
   * 問診送信ボタンクリック時
   * @param {} なし
   * @return {} なし
   */
  const handleSendClick = async () => {
    // 問診送信
    try {
      const answerInfo = globalAnswerInformation?.map((answer) => {
        const response = answer.answer;
        return {
          questionId: answer.questionId,
          questionPosition: answer.questionPosition,
          answer: Array.isArray(response) ? response.join(", ") : response,
        };
      });

      const data = await registPatientMedicalQuestionnaire(
        globalMedicalInstitutionId,
        globalQuestionnaireToken,
        answerInfo
      );

      if (data.result.status === "OK") {
        // 問診完了画面に遷移
        navigate("/questionnaire-done");
      } else {
        // エラーメッセージセット
        setErrorMessage(data?.result?.error_message);
      }
    } catch (error) {
      console.error("Error reservationSend:", error);
      showToast("問診送信に失敗しました", "error");
    }
  };

  /**
   * 戻るボタンクリック時
   * @param {} なし
   * @return {} なし
   */
  const handleBackClick = () => {
    // 問診入力画面に遷移
    navigate(
      `/questionnaire-entry?token=${globalQuestionnaireToken}#medicalInstitutionId=${globalMedicalInstitutionId}`
    );
  };

  // トースト通知を表示する関数
  const showToast = (content, type) => {
    const key = `open${Date.now()}`;
    const closeToast = () => {
      message.destroy(key);
    };

    message.open({
      content: <Toast content={content} type="check" onClose={closeToast} />,
      key,
      className: `ant-message-notice-content-${type}`,
    });
  };

  return (
    <div className="questionnaire-confirm">
      <SubHeader clinicName={globalMedicalInstitutionName} />
      <div className="main-area">
        <div className="title">問診内容の確認</div>
        {errorMessage && (
          <div className="error-area">
            <div className="icon-area">
              <WarningFilled className="icon" />
            </div>
            <label>{errorMessage}</label>
          </div>
        )}
        <div className="detail">
          問診記入をご確認の上、問診送信ボタンを押してください。
        </div>
        <div className="questionnaire-info-area">
          {globalAnswerInformation && globalAnswerInformation.length > 0
            ? globalAnswerInformation.map((answerInfo, index) => (
                <div key={`answer-${index}`} className="answer-info-area">
                  <div className="question-label">{answerInfo.contents}</div>
                  <div className="answer-label">
                    {Array.isArray(answerInfo.answer)
                      ? answerInfo.answer.join("、")
                      : answerInfo.answer}
                  </div>
                </div>
              ))
            : ""}
        </div>
        <GeneralButton
          buttonLabel={"問診送信"}
          type={"primary-blue"}
          onClick={() => handleSendClick()}
        />
        <GeneralButton
          buttonLabel={"問診選択に戻る"}
          type={"secondary-white"}
          onClick={() => handleBackClick()}
        />
      </div>
    </div>
  );
}

export default QuestionnaireConfirmPage;
